"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _labeling = _interopRequireDefault(require("../../containers/labeling"));
var _Footer = _interopRequireDefault(require("../Footer"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _submitConsents = _interopRequireDefault(require("../../api/Customer/submitConsents"));
var _getCustomerConsents = _interopRequireDefault(require("../../api/Customer/getCustomerConsents"));
var _MyAccountConsents = _interopRequireDefault(require("../MyAccountConsents"));
var _reactRedux = require("react-redux");
var _userProfile = require("../../redux/userProfile");
var _PopupStyled = require("./PopupStyled");
var _Popup = _interopRequireDefault(require("./Popup.const"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var WelcomeIcon = function WelcomeIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "m52.597 33.047-3.234-12.066a6.435 6.435 0 0 0-7.881-4.55 6.435 6.435 0 0 0-3.907 3 6.435 6.435 0 0 0-.643 4.883l1.251 4.668 4.438 16.564",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m53.657 32.763-3.233-12.066a7.533 7.533 0 0 0-9.226-5.328 7.534 7.534 0 0 0-4.574 3.51 7.533 7.533 0 0 0-.752 5.717l5.689 21.232a1.1 1.1 0 0 0 1.346.777 1.1 1.1 0 0 0 .777-1.346l-5.691-21.231a5.335 5.335 0 0 1 .533-4.049 5.336 5.336 0 0 1 3.24-2.486 5.336 5.336 0 0 1 6.535 3.776l3.233 12.066a1.1 1.1 0 0 0 1.346.777 1.1 1.1 0 0 0 .777-1.349Z",
    fill: "#bcc2d4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m99.377 29.874 4.293-16.021a6.435 6.435 0 0 0-.643-4.883 6.434 6.434 0 0 0-3.907-3 6.434 6.434 0 0 0-4.883.643 6.435 6.435 0 0 0-3 3.907l-5.69 21.234",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m100.438 30.159 4.293-16.02a7.533 7.533 0 0 0-.752-5.717 7.534 7.534 0 0 0-4.574-3.51 7.533 7.533 0 0 0-5.717.753 7.533 7.533 0 0 0-3.51 4.574l-5.691 21.232a1.1 1.1 0 0 0 .777 1.346 1.1 1.1 0 0 0 1.346-.777l5.688-21.232a5.335 5.335 0 0 1 2.486-3.24 5.336 5.336 0 0 1 4.049-.533 5.335 5.335 0 0 1 3.24 2.486 5.334 5.334 0 0 1 .533 4.049l-4.291 16.02a1.1 1.1 0 0 0 .777 1.346 1.1 1.1 0 0 0 1.346-.777Z",
    fill: "#bcc2d4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m108.717 30.565 5.724-21.364a6.434 6.434 0 0 0-.643-4.883 6.435 6.435 0 0 0-3.907-3 6.435 6.435 0 0 0-7.881 4.55l-6.254 23.339",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m109.778 30.85 5.725-21.364a7.534 7.534 0 0 0-.753-5.717 7.533 7.533 0 0 0-4.574-3.51 7.533 7.533 0 0 0-9.227 5.327l-6.254 23.337a1.1 1.1 0 0 0 .777 1.346 1.1 1.1 0 0 0 1.346-.773l6.25-23.342a5.336 5.336 0 0 1 6.535-3.773 5.335 5.335 0 0 1 3.24 2.486 5.336 5.336 0 0 1 .533 4.049l-5.721 21.365a1.1 1.1 0 0 0 .777 1.346 1.1 1.1 0 0 0 1.346-.777Z",
    fill: "#bcc2d4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m117.098 33.591 6.374-23.788a6.435 6.435 0 0 0-.643-4.883 6.435 6.435 0 0 0-3.907-3 6.435 6.435 0 0 0-7.881 4.55l-6.254 23.339",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m118.157 33.876 6.374-23.789a7.533 7.533 0 0 0-.753-5.717 7.534 7.534 0 0 0-4.574-3.51 7.533 7.533 0 0 0-9.226 5.327l-6.252 23.337a1.1 1.1 0 0 0 .777 1.346 1.1 1.1 0 0 0 1.346-.777l6.253-23.337a5.336 5.336 0 0 1 6.535-3.773 5.336 5.336 0 0 1 3.24 2.486 5.334 5.334 0 0 1 .533 4.049l-6.373 23.789a1.1 1.1 0 0 0 .777 1.346 1.1 1.1 0 0 0 1.343-.777Z",
    fill: "#bcc2d4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m124.932 39.162 4.911-18.327a6.435 6.435 0 0 0-4.55-7.881 6.435 6.435 0 0 0-7.881 4.55l-3.9 14.539",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m125.993 39.449 4.911-18.327a7.533 7.533 0 0 0-5.327-9.226 7.533 7.533 0 0 0-9.226 5.327l-3.9 14.539a1.1 1.1 0 0 0 .777 1.346 1.1 1.1 0 0 0 1.346-.777l3.9-14.539a5.336 5.336 0 0 1 6.535-3.773 5.335 5.335 0 0 1 3.772 6.53l-4.91 18.327a1.1 1.1 0 0 0 .777 1.346 1.1 1.1 0 0 0 1.345-.773Z",
    fill: "#bcc2d4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m116.642 48.602.709-1.793a37.577 37.577 0 0 1 6.511-10.751l3.218-3.724a5.518 5.518 0 0 1 6.657-1.321l.477.24a5.934 5.934 0 0 1 3.18 4.3 5.934 5.934 0 0 1-1.566 5.111 38.19 38.19 0 0 0-8.164 12.936l-1.69 4.465q-.045.122-.1.24c-.585 1.242-5.043 10.04-13.259 7.706-8.835-2.51-12.229-9.094-9-17.975",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m117.664 49.006.709-1.793a36.478 36.478 0 0 1 6.321-10.438l3.218-3.724a4.419 4.419 0 0 1 5.331-1.058l.477.24a4.836 4.836 0 0 1 2.591 3.5 4.835 4.835 0 0 1-1.276 4.165 39.29 39.29 0 0 0-8.4 13.309l-1.689 4.468a3.366 3.366 0 0 1-.074.18 16.96 16.96 0 0 1-3.515 4.84 8.487 8.487 0 0 1-8.442 2.259c-4.069-1.156-6.916-3.208-8.344-6.036s-1.417-6.405.073-10.506a1.1 1.1 0 0 0-.658-1.408 1.1 1.1 0 0 0-1.408.658c-1.736 4.78-1.637 8.942.031 12.247s4.94 5.806 9.705 7.16a10.593 10.593 0 0 0 10.541-2.766 19.334 19.334 0 0 0 4.014-5.528c.054-.121.1-.223.135-.326l1.684-4.461a37.09 37.09 0 0 1 7.929-12.564 7.033 7.033 0 0 0 1.856-6.058 7.033 7.033 0 0 0-3.765-5.091l-.477-.24a6.617 6.617 0 0 0-7.982 1.584l-3.218 3.724a38.675 38.675 0 0 0-6.7 11.066l-.709 1.793Z",
    fill: "#bcc2d4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M84.585 31.11s-2.949 9.413-1.422 18.059c1.057 5.984 4.209 11.591 11.692 13.736a1.1 1.1 0 0 0 1.359-.754 1.1 1.1 0 0 0-.754-1.361c-6.517-1.866-9.213-6.792-10.133-12-1.439-8.148 1.355-17.018 1.355-17.018a1.1 1.1 0 0 0-.719-1.378 1.1 1.1 0 0 0-1.378.716Z",
    fill: "#bcc2d4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M85.698 31.199s22.86-6.008 36.951 6.382",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M85.977 32.263a55.4 55.4 0 0 1 17.47-1.186c6.208.61 13.024 2.537 18.476 7.33a1.1 1.1 0 0 0 1.551-.1 1.1 1.1 0 0 0-.1-1.551c-5.821-5.118-13.084-7.215-19.715-7.867a57.686 57.686 0 0 0-18.244 1.248 1.1 1.1 0 0 0-.783 1.342 1.1 1.1 0 0 0 1.345.784Z",
    fill: "#bcc2d4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m75.447 35.505 1.674-9.6a5.586 5.586 0 0 1 5.183-4.617l.407-.023a5.934 5.934 0 0 1 4.9 2.131 5.934 5.934 0 0 1 1.2 5.21 38.191 38.191 0 0 0-.6 15.285l.723 4.418a8.364 8.364 0 0 1 .1.963c.062 2.364-.089 11.345-6.406 13.037",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m76.529 35.694 1.674-9.6a4.487 4.487 0 0 1 4.168-3.714l.407-.023a4.835 4.835 0 0 1 3.993 1.737 4.836 4.836 0 0 1 .977 4.245 39.29 39.29 0 0 0-.62 15.725l.723 4.418a7.263 7.263 0 0 1 .088.837 19.709 19.709 0 0 1-1.312 7.9 6.581 6.581 0 0 1-4.281 4.021 1.1 1.1 0 0 0-.775 1.352 1.1 1.1 0 0 0 1.346.777 8.715 8.715 0 0 0 5.723-5.257 22.22 22.22 0 0 0 1.5-8.87 9.483 9.483 0 0 0-.116-1.113l-.723-4.417a37.1 37.1 0 0 1 .585-14.846 7.033 7.033 0 0 0-1.421-6.175 7.033 7.033 0 0 0-5.811-2.526l-.407.023a6.685 6.685 0 0 0-6.2 5.526l-1.674 9.6a1.1 1.1 0 0 0 .894 1.271 1.1 1.1 0 0 0 1.262-.891Z",
    fill: "#bcc2d4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m61.357 30.181-4.992-18.615a6.435 6.435 0 0 0-7.881-4.55 6.435 6.435 0 0 0-3.907 3 6.435 6.435 0 0 0-.643 4.883l6.211 23.181",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m62.414 29.896-4.988-18.615a7.533 7.533 0 0 0-9.227-5.327 7.533 7.533 0 0 0-4.575 3.51 7.533 7.533 0 0 0-.753 5.717l6.211 23.181a1.1 1.1 0 0 0 1.346.777 1.1 1.1 0 0 0 .78-1.346l-6.214-23.18a5.336 5.336 0 0 1 .533-4.049 5.335 5.335 0 0 1 3.24-2.486 5.336 5.336 0 0 1 6.541 3.772l4.988 18.615a1.1 1.1 0 0 0 1.346.777 1.1 1.1 0 0 0 .772-1.346Z",
    fill: "#bcc2d4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M70.861 31.36 64.487 7.571a6.435 6.435 0 0 0-3-3.907 6.434 6.434 0 0 0-4.883-.643 6.434 6.434 0 0 0-3.907 3 6.434 6.434 0 0 0-.643 4.883l6.621 24.705",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M71.926 31.075 65.548 7.287a7.534 7.534 0 0 0-3.51-4.574 7.534 7.534 0 0 0-5.717-.753 7.534 7.534 0 0 0-4.574 3.51 7.534 7.534 0 0 0-.753 5.717l6.62 24.705a1.1 1.1 0 0 0 1.346.777 1.1 1.1 0 0 0 .777-1.346l-6.621-24.705a5.336 5.336 0 0 1 .533-4.049 5.336 5.336 0 0 1 3.24-2.486 5.336 5.336 0 0 1 4.049.533 5.336 5.336 0 0 1 2.486 3.24l6.374 23.788a1.1 1.1 0 0 0 1.346.777 1.1 1.1 0 0 0 .782-1.346Z",
    fill: "#bcc2d4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M83.125 42.324 75.52 13.943a6.434 6.434 0 0 0-3-3.907 6.435 6.435 0 0 0-4.883-.643 6.435 6.435 0 0 0-3.907 3 6.435 6.435 0 0 0-.643 4.883l4.288 16",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m84.186 42.039-7.605-28.382a7.533 7.533 0 0 0-3.51-4.574 7.533 7.533 0 0 0-5.717-.752 7.533 7.533 0 0 0-4.574 3.51 7.533 7.533 0 0 0-.752 5.717l4.288 16a1.1 1.1 0 0 0 1.346.777 1.1 1.1 0 0 0 .777-1.346l-4.288-16a5.335 5.335 0 0 1 .533-4.049 5.335 5.335 0 0 1 3.24-2.486 5.335 5.335 0 0 1 4.049.533 5.336 5.336 0 0 1 2.486 3.24l7.605 28.382a1.1 1.1 0 0 0 1.346.777 1.1 1.1 0 0 0 .776-1.347Z",
    fill: "#bcc2d4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M59.003 67.798c-5.084-1.031-8.905-4.621-11.65-8.689a45.484 45.484 0 0 1-5.889-13.639 1.1 1.1 0 0 1 .831-1.313 1.1 1.1 0 0 1 1.313.831 43 43 0 0 0 5.567 12.892c2.577 3.819 6.169 7.244 11.091 7.9a1.1 1.1 0 0 1 .952 1.061s.309 13.437-10.359 19.124a1.1 1.1 0 1 1-1.032-1.942c7.962-4.242 9.038-13.34 9.176-16.225Z",
    fill: "#bcc2d4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M115.687 67.06s-.31 13.433 10.359 19.12a1.1 1.1 0 0 0 1.034-1.939c-9.536-5.083-9.2-17.124-9.2-17.124a1.1 1.1 0 0 0-1.07-1.127 1.1 1.1 0 0 0-1.123 1.07Z",
    fill: "#bcc2d4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M81.459 62.64c1.032 3.74.6 9.3-1.039 14.68s-4.501 10.596-8.46 13.606a1.1 1.1 0 1 0 1.332 1.748c4.289-3.267 7.45-8.883 9.23-14.713s2.174-11.855 1.056-15.907a1.1 1.1 0 0 0-1.352-.767 1.1 1.1 0 0 0-.767 1.353Z",
    fill: "#bcc2d4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M94.004 62.055c-1.119 4.051-.724 10.078 1.055 15.906s4.941 11.447 9.23 14.713a1.1 1.1 0 0 0 1.332-1.748c-3.957-3.01-6.818-8.228-8.46-13.61s-2.071-10.94-1.039-14.68a1.1 1.1 0 0 0-.767-1.352 1.1 1.1 0 0 0-1.351.771Z",
    fill: "#bcc2d4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.691 28.269H1.268A1.269 1.269 0 0 0 0 29.537a1.269 1.269 0 0 0 1.268 1.268h25.423a1.269 1.269 0 0 0 1.268-1.268 1.268 1.268 0 0 0-1.268-1.268Z",
    fill: "#4eb7a1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.691 38.809h-4.363a1.269 1.269 0 0 0-1.268 1.268 1.269 1.269 0 0 0 1.268 1.273h4.363a1.269 1.269 0 0 0 1.268-1.268 1.268 1.268 0 0 0-1.268-1.273Z",
    fill: "#4eb7a1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.691 49.7h-6.289a1.269 1.269 0 0 0-1.268 1.268 1.269 1.269 0 0 0 1.268 1.268h6.289a1.269 1.269 0 0 0 1.268-1.268 1.269 1.269 0 0 0-1.268-1.268Z",
    fill: "#4eb7a1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.334 38.809H5.886a1.268 1.268 0 0 0-1.268 1.268 1.269 1.269 0 0 0 1.268 1.273h12.448a1.269 1.269 0 0 0 1.268-1.268 1.269 1.269 0 0 0-1.268-1.273Z",
    fill: "#4eb7a1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.033 49.7H3.551a1.269 1.269 0 0 0-1.268 1.271 1.269 1.269 0 0 0 1.268 1.268h12.482a1.269 1.269 0 0 0 1.268-1.268 1.269 1.269 0 0 0-1.268-1.271Z",
    fill: "#4eb7a1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M147.501 30.805h25.423a1.269 1.269 0 0 0 1.268-1.268 1.268 1.268 0 0 0-1.268-1.268h-25.423a1.268 1.268 0 0 0-1.264 1.268 1.269 1.269 0 0 0 1.264 1.268Z",
    fill: "#4eb7a1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M147.501 41.35h4.363a1.269 1.269 0 0 0 1.268-1.268 1.269 1.269 0 0 0-1.268-1.268h-4.363a1.268 1.268 0 0 0-1.264 1.263 1.269 1.269 0 0 0 1.264 1.273Z",
    fill: "#4eb7a1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M147.501 52.239h6.289a1.269 1.269 0 0 0 1.268-1.268 1.269 1.269 0 0 0-1.268-1.271h-6.289a1.269 1.269 0 0 0-1.264 1.271 1.269 1.269 0 0 0 1.264 1.268Z",
    fill: "#4eb7a1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M155.859 41.35h12.448a1.269 1.269 0 0 0 1.268-1.268 1.269 1.269 0 0 0-1.268-1.268h-12.448a1.269 1.269 0 0 0-1.268 1.268 1.269 1.269 0 0 0 1.268 1.268Z",
    fill: "#4eb7a1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M158.158 52.239h12.482a1.269 1.269 0 0 0 1.268-1.268 1.269 1.269 0 0 0-1.268-1.271h-12.482a1.269 1.269 0 0 0-1.268 1.271 1.269 1.269 0 0 0 1.268 1.268Z",
    fill: "#4eb7a1"
  }))));
};
WelcomeIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "174.192",
  height: "92.9"
};
var ConsentsIcon = function ConsentsIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M81.292 27.673a3.075 3.075 0 0 0-.9-2.174 3.075 3.075 0 0 0-2.174-.9H13.543a3.075 3.075 0 0 0-2.174.9 3.075 3.075 0 0 0-.9 2.174v92.606a3.074 3.074 0 0 0 3.074 3.074h64.675a3.074 3.074 0 0 0 3.074-3.074Zm-1.685 0v92.606a1.39 1.39 0 0 1-1.39 1.39H13.543a1.39 1.39 0 0 1-1.39-1.39V27.673a1.39 1.39 0 0 1 .407-.983 1.39 1.39 0 0 1 .983-.407h64.675a1.39 1.39 0 0 1 .983.407 1.39 1.39 0 0 1 .407.983Z",
    fill: "#bcc2d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M91.266 8.997a9 9 0 0 0-2.635-6.362A9 9 0 0 0 82.27 0H8.996a9 9 0 0 0-6.362 2.635A9 9 0 0 0-.001 8.997v119.711a9 9 0 0 0 9 9h73.27a9 9 0 0 0 9-9Zm-3.159 0v119.711a5.838 5.838 0 0 1-5.838 5.838H8.996a5.838 5.838 0 0 1-5.838-5.838V8.997a5.838 5.838 0 0 1 1.71-4.128 5.838 5.838 0 0 1 4.128-1.71h73.273a5.838 5.838 0 0 1 4.128 1.71 5.838 5.838 0 0 1 1.71 4.128Z",
    fill: "#bcc2d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(68.457 107.587)",
    fill: "#fff",
    stroke: "#fff"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "17.006",
    cy: "17.006",
    r: "17.006",
    stroke: "none"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "17.006",
    cy: "17.006",
    r: "16.506",
    fill: "none"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.143 15.378h20.979a1.791 1.791 0 0 0 1.79-1.79 1.791 1.791 0 0 0-1.79-1.79H35.143a1.791 1.791 0 0 0-1.79 1.79 1.791 1.791 0 0 0 1.79 1.79Z",
    fill: "#bcc2d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M85.755 115.223c.968 0 2.363.163 2.393 1.253a10.412 10.412 0 0 1-.114 1.253c-.285 1.823-1.112 6.295-1.595 9.884h-1.368c-.4-3.3-1.224-7.831-1.566-9.8a7.291 7.291 0 0 1-.2-1.339c0-.994 1.424-1.251 2.45-1.251Zm.028 19.253h-.042a2.389 2.389 0 0 1-2.378-2.378 2.389 2.389 0 0 1 2.378-2.378 2.389 2.389 0 0 1 2.378 2.363v.143a2.262 2.262 0 0 1-2.251 2.251h-.091Z",
    fill: "#4eb6a1"
  })), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(68.457 107.587)",
    fill: "none",
    stroke: "#4eb6a1",
    strokeWidth: "2.7"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "17.006",
    cy: "17.006",
    r: "17.006",
    stroke: "none"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "17.006",
    cy: "17.006",
    r: "15.656"
  }))), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    stroke: "#bcc2d4",
    strokeLinecap: "round",
    strokeWidth: "4"
  }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M45.19 76.599h24.421"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M32.275 76.599h6.143"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.469 69.599h3.1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M32.275 69.599h37.337"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M32.276 89.599h25.027"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M63.469 89.599h6.143"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.469 89.599h3.1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M32.275 96.599h37.337"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M32.193 49.599H69.53"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M32.193 56.599h17.448"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M56.29 56.599h13.221"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.469 49.599h3.419"
  })))))));
};
ConsentsIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "102.469",
  height: "141.599"
};
var Popup = function Popup(_ref) {
  var t = _ref.t;
  var _useState = (0, _react.useState)(1),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    updatedConsents = _useState4[0],
    setUpdatedConsents = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    allowSubmitConsents = _useState8[0],
    setAllowSubmitConsents = _useState8[1];
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.popup;
    }),
    popupType = _useSelector.popupType,
    consents = _useSelector.consents;
  var dispatch = (0, _reactRedux.useDispatch)();
  var checkAccess = function checkAccess(items) {
    var shouldBlockConfirmButton = items.find(function (_ref2) {
      var required = _ref2.required,
        state = _ref2.state;
      return required && state === 'declined';
    });
    setAllowSubmitConsents(!shouldBlockConfirmButton);
  };
  (0, _react.useEffect)(function () {
    setUpdatedConsents(consents);
    checkAccess(consents);
  }, []);
  var handleSubmitConsents = function handleSubmitConsents() {
    var payload = updatedConsents.map(function (_ref3) {
      var name = _ref3.name,
        newestVersion = _ref3.newestVersion,
        state = _ref3.state;
      return {
        name: name,
        version: newestVersion,
        state: state
      };
    });
    setIsLoading(true);
    (0, _submitConsents.default)([], [], payload).then(function () {
      (0, _getCustomerConsents.default)().then(function (_ref4) {
        var responseData = _ref4.responseData;
        dispatch((0, _userProfile.setConsents)(responseData.consents));
      });
    });
  };
  var handleActionButton = function handleActionButton() {
    if (_Popup.default[popupType] === 'consentsUpdateRequired' || step === 2) {
      handleSubmitConsents();
      return;
    }
    setStep(function (prevStep) {
      return prevStep + 1;
    });
  };
  var stepData = _Popup.default[popupType].steps[step - 1];
  var steps = _Popup.default[popupType].steps;
  var renderIcon = function renderIcon() {
    if (!stepData.icon) return null;
    if (_Popup.default[popupType] === 'notCheckedTerms') {
      return /*#__PURE__*/_react.default.createElement(WelcomeIcon, null);
    }
    return /*#__PURE__*/_react.default.createElement(ConsentsIcon, null);
  };
  return /*#__PURE__*/_react.default.createElement(_PopupStyled.WrapperStyled, null, /*#__PURE__*/_react.default.createElement(_PopupStyled.HeaderStyled, null, /*#__PURE__*/_react.default.createElement(_PopupStyled.DotsWrapperStyled, {
    currentStep: step
  }, steps.length > 1 && steps.map(function (_ref5) {
    var title = _ref5.title;
    return /*#__PURE__*/_react.default.createElement(_PopupStyled.DotStyled, {
      key: title
    });
  })), /*#__PURE__*/_react.default.createElement(_PopupStyled.HeaderTitleStyled, null, t(stepData.headerTitle))), /*#__PURE__*/_react.default.createElement(_PopupStyled.ContentStyled, {
    step: consents.length ? step : 1
  }, renderIcon(), /*#__PURE__*/_react.default.createElement(_PopupStyled.TitleStyled, {
    step: step
  }, t(stepData.title)), /*#__PURE__*/_react.default.createElement(_PopupStyled.TextStyled, {
    step: step
  }, t(stepData.text)), step === 2 && consents &&
  /*#__PURE__*/
  // TODO: Remove setConsents and consents props and use redux in MyAccountConsents
  _react.default.createElement(_MyAccountConsents.default, {
    consents: consents,
    showConsentsOnly: true,
    saveConsents: function saveConsents(items) {
      setUpdatedConsents(items);
      checkAccess(items);
    },
    setConsents: _userProfile.setConsents
  })), /*#__PURE__*/_react.default.createElement(_PopupStyled.ButtonWrapperStyled, null, /*#__PURE__*/_react.default.createElement(_PopupStyled.InnerWrapperStyled, null, /*#__PURE__*/_react.default.createElement(_PopupStyled.ButtonStyled, {
    onClickFn: handleActionButton,
    disabled: step === 2 && !allowSubmitConsents,
    width: "auto"
  }, isLoading && /*#__PURE__*/_react.default.createElement(_Loader.default, {
    buttonLoader: true,
    color: "#ffffff"
  }) || t(stepData.buttonText)))), /*#__PURE__*/_react.default.createElement(_Footer.default, {
    isCheckout: false
  }));
};
Popup.propTypes = {
  t: _propTypes.default.func
};
Popup.defaultProps = {
  t: function t(k) {
    return k;
  }
};
var _default = (0, _reactI18next.withTranslation)()((0, _labeling.default)()(Popup));
exports.default = _default;